import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="M6 22h5.682l1.12-3.828h6.396L20.318 22H26L19.599 2h-7.197L6 22zm12.008-7.89-1.932-6.602h-.152l-1.932 6.601h4.016z" clip-rule="evenodd"></path><path d="M5 24h22a3 3 0 1 1 0 6H5a3 3 0 1 1 0-6z"></path></g>';
export var TextColorSVG = function TextColorSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
TextColorSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TextColorSVG);